













import Vue from 'vue'
import SpacingSection from '@/components/Typography/UiPreviewSection/spacing.vue'
import WidthSection from '@/components/Typography/UiPreviewSection/width.vue'
import FontSizeSection from '@/components/Typography/UiPreviewSection/fontSize.vue'
import FontWeightSection from '@/components/Typography/UiPreviewSection/fontWeight.vue'
import LetterSpacingSection from '@/components/Typography/UiPreviewSection/letterSpacing.vue'
import LineHeightSection from '@/components/Typography/UiPreviewSection/lineHeight.vue'
import { mapState, mapGetters } from 'vuex'
import { GETTERS_ACTIONS } from '@/types'

export default Vue.extend({
  components: {
    SpacingSection,
    WidthSection,
    FontSizeSection,
    FontWeightSection,
    LetterSpacingSection,
    LineHeightSection
  },
  computed: {
    ...mapState(['tailwindConfig']),
    ...mapGetters([GETTERS_ACTIONS.USE_WIDTH_PREVIEW])
  }
})
